module.exports = __webpack_public_path__ + "static/media/BOI.30a2f57c.svg";